import { UserType } from 'src/app/interfaces/user';
import { AuthService } from './../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  form: FormGroup;
  isLoading: boolean;
  message: string;

  secondScreen = false;
  secondScreenType: UserType;
  secondScreenUID: string;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.form = this.fb.group({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    })
  }

  async submit(){
    try{
      this.isLoading = true;

      if(this.form.invalid){
        throw Error('Form is invalid');
      }

      this.auth.login({username: this.form.value.email, password: this.form.value.password}).subscribe(async (res) => {
        if(res && res.data){
          const user = await this.auth.getUser();

          if(user){
            if(this.route.snapshot.queryParams && this.route.snapshot.queryParams.redirect_url){
              this.router.navigate(_.split(this.route.snapshot.queryParams.redirect_url, '/'));
              return;
            }

            if(user.type === UserType.Teacher || user.type === UserType.Student){
              this.router.navigate(['/profile']);
              return;
            }

            this.router.navigate(['/']);
            return;
          }else{
            this.secondScreen = true;
            this.secondScreenType = +res.data.type as UserType;
            this.secondScreenUID = res.data._id;
          }
        }
      })

    }catch(e){
      console.error(e);

      this.message = e.message;

    }finally{
      this.isLoading = false;
    }
  }
}
